
import { item, map } from "../../fable_modules/fable-library-js.5.0.0/Array.js";
import { ViewHelpers_spanWith, WeatherValue_Definition, WeatherValue_TrendType, WeatherValue_WeatherBox, WeatherValue_Unit, ColorHsl } from "./PortWindCommon.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { ofArray, singleton, empty, indexed, map as map_2, mapIndexed, collect, length, filter, tryFind } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { comparePrimitives, createObj, equals } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { QuayVisualType, SensorId__get_Value } from "../../StenaWeather.Domain/PortWind.js";
import { contains } from "../../fable_modules/fable-library-js.5.0.0/Set.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { directionArrow, ship_at_quay as ship_at_quay_1 } from "../../images/ship_at_quay.svg.js";
import { Color, theme } from "../../Theme.js";
import { max } from "../../fable_modules/fable-library-js.5.0.0/Double.js";
import { op_UnaryNegation_Int32 } from "../../fable_modules/fable-library-js.5.0.0/Int32.js";
import { svg_transform_rotateCenter } from "../../Feliz.js";
import { singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { rotateDirection180 } from "../Common.js";
import { IconModule_View } from "../../Components/StenaWebUI/Icons/Icon.js";
import { ofList } from "../../fable_modules/fable-library-js.5.0.0/Map.js";

export const sensorColorPalette = (() => {
    const lightnesses = new Int32Array([50, 35, 65, 23, 75]);
    return map((h) => map((l) => (new ColorHsl(h, 80, l)), lightnesses), new Int32Array([0, 210, 120, 30, 270, 180, 60, 300, 150, 90]));
})();

export function getSensorName(sensors, sensorId) {
    return defaultArg(map_1((s_1) => s_1.Name, tryFind((s) => equals(s.SensorId, sensorId), sensors)), SensorId__get_Value(sensorId));
}

/**
 * A weather box for a value definition: directional values render a rotating arrow, all others a plain value.
 */
export function boxFromDefinition(d) {
    if (equals(d.Unit, new WeatherValue_Unit(1, []))) {
        return new WeatherValue_WeatherBox(1, [d]);
    }
    else {
        return new WeatherValue_WeatherBox(0, [d]);
    }
}

/**
 * When the selected sensor is a group, replicate each value definition per visible child sensor,
 * tagging chart names and (when more than one child is visible) assigning distinct colors.
 */
export function expandForGroupSensor(sensor, hiddenSensors, getSensorName_1, defs) {
    let matchResult, s_1;
    if (sensor != null) {
        if (!equals(sensor.GroupChildrens, empty())) {
            matchResult = 0;
            s_1 = sensor;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const visibleChildren = filter((childId) => !contains(childId, hiddenSensors), s_1.GroupChildrens);
            const useDistinctColors = length(visibleChildren) > 1;
            return collect((x) => x, mapIndexed((sensorIdx, tupledArg) => map_2((tupledArg_1) => {
                const d = tupledArg_1[1];
                let colorOverride;
                if (useDistinctColors) {
                    const shades = item(sensorIdx % sensorColorPalette.length, sensorColorPalette);
                    colorOverride = item(tupledArg_1[0] % shades.length, shades);
                }
                else {
                    colorOverride = undefined;
                }
                return new WeatherValue_Definition(d.Id, d.Label, concat(d.ChartName, " (", tupledArg[1], ...")"), d.ValueFormat, d.Unit, d.Icon, (useDistinctColors && equals(d.ChartType, new WeatherValue_TrendType(1, []))) ? (new WeatherValue_TrendType(0, [])) : d.ChartType, d.ChartColor, colorOverride, (state, w) => {
                    if (equals(w.SensorId, tupledArg[0])) {
                        return d.GetValue(state, w);
                    }
                    else {
                        return undefined;
                    }
                });
            }, indexed(defs)), map_2((id) => [id, getSensorName_1(id)], visibleChildren)));
        }
        default:
            return defs;
    }
}

/**
 * Ship-at-quay box: the vessel and the wind arrow rotate relative to the quay orientation.
 */
export function quayWeatherValue(windDir, q) {
    let value;
    const ship_at_quay = ship_at_quay_1(theme(new Color(4, [])), q.FlipVessel, equals(q.VisualType, new QuayVisualType(1, [])));
    const arrow = directionArrow(theme(new Color(4, [])), theme(new Color(5, [])));
    const h = ship_at_quay.Height;
    const w = ship_at_quay.Width;
    const r = max(w, h);
    const windRot = windDir;
    let rot;
    const x = (q.Orientation - windRot) % 360;
    rot = ((x < 0) ? (360 + x) : x);
    const moveY = op_UnaryNegation_Int32(~~(arrow.Height * ((value = (((windRot / 2) * 3.141592653589793) / 180), Math.sin(value))))) | 0;
    return new WeatherValue_WeatherBox(4, [{
        Flip: q.FlipVessel,
        Label: q.Label,
        Svg: ship_at_quay.Svg,
        SvgArrow: arrow.Svg,
        SvgTransform: singleton(svg_transform_rotateCenter(rot, r / 2, r / 2)),
        WholeSvgTransform: ofArray([svg_transform_rotateCenter(windRot, w / 2, h / 2), ["transform", ((("translate(" + 0) + ",") + moveY) + ")"], ["transform", ("scale(" + 0.9) + ")"]]),
    }]);
}

export const Style_clickableIcon = ofArray([["alignSelf", "center"], ["cursor", "pointer"]]);

export const Style_clearAllButton = ofArray([["cursor", "pointer"], ["alignSelf", "center"], ["marginRight", 1 + "vmin"], ["fontSize", 2.5 + "vmin"], ["lineHeight", 1], ["color", theme(new Color(0, []))], ["opacity", 0.5]]);

export const Style_dashboardRoot = ofArray([["backgroundColor", theme(new Color(1, []))], ["color", theme(new Color(0, []))], ["height", 100 + "%"]]);

export function Style_lastUpdatedBackground(isStale) {
    return singleton(["backgroundColor", isStale ? theme(new Color(17, [])) : theme(new Color(1, []))]);
}

/**
 * Icon style for a directional value: base margin plus a rotation for the direction arrow.
 */
export function Style_directionIcon(iconMargin, value) {
    return toList(delay(() => append(iconMargin, delay(() => singleton_1(["transform", ("rotate(" + ~~rotateDirection180(value)) + "deg)"])))));
}

export function Style_mapBoxInner(columnWidth, rowHeight) {
    return ofArray([["width", (columnWidth * 0.75) + "vw"], ["height", (rowHeight - 13) + "vh"]]);
}

export function Style_weatherBoxContainer(boxMargin) {
    return ofArray([["backgroundColor", theme(new Color(5, []))], ["borderRadius", 1 + "vmin"], ["marginRight", (boxMargin * 2) + "vmax"], ["marginBottom", (boxMargin * 2) + "vmax"], ["position", "relative"]]);
}

export const Style_sensorLabel = ofArray([["position", "absolute"], ["bottom", 1 + "vmin"], ["right", 1.5 + "vmin"], ["fontSize", 2 + "vmin"], ["color", theme(new Color(4, []))], ["opacity", 0.6]]);

/**
 * A clickable icon button styled for the dashboard header (BoxBackground coloured icon).
 */
export function clickableIcon(size, extraProps, onClick, iconName) {
    return ViewHelpers_spanWith(toList(delay(() => append(singleton_1(["onClick", onClick]), delay(() => append(singleton_1(["style", createObj(Style_clickableIcon)]), delay(() => extraProps)))))), singleton(IconModule_View(ofList(map_2((value_2) => value_2, ofArray([["icon", iconName], ["color", theme(new Color(5, []))], ["size", size]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }))));
}

/**
 * The "+"/"×" toggle used to select-all / clear-all a checkbox group.
 */
export function clearAllButton(dispatch, allHidden, selectAllMsg, deselectAllMsg) {
    const msg = allHidden ? selectAllMsg : deselectAllMsg;
    return ViewHelpers_spanWith([["onClick", (_arg) => {
        dispatch(msg);
    }], ["style", createObj(Style_clearAllButton)]], singleton(allHidden ? "+" : "×"));
}

